var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1986 11.2867C8.0481 11.2867 7.89763 11.2292 7.78289 11.1145L4.17226 7.50386C3.94258 7.27417 3.94258 6.90178 4.17226 6.67219C4.40185 6.4426 4.77417 6.4426 5.00387 6.67219L8.1986 9.86711L11.3933 6.6723C11.623 6.44271 11.9953 6.44271 12.2249 6.6723C12.4547 6.90189 12.4547 7.27429 12.2249 7.50397L8.61431 11.1146C8.49952 11.2293 8.34904 11.2867 8.1986 11.2867Z",
    fill: "#2B2F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuArrow);
export default __webpack_public_path__ + "static/media/ICON_MENU_ARROW.e9447a3227c9b380874c023aea33f7aa.svg";
export { ForwardRef as ReactComponent };